import { render, staticRenderFns } from "./guessing-champion.vue?vue&type=template&id=e7586c5a&scoped=true&"
import script from "./guessing-champion.vue?vue&type=script&lang=js&"
export * from "./guessing-champion.vue?vue&type=script&lang=js&"
import style0 from "./guessing-champion.vue?vue&type=style&index=0&id=e7586c5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7586c5a",
  null
  
)

export default component.exports